import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74ba6a3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex align-items-center gap-3 h-full\" data-v-74ba6a3b><i class=\"ci-icon-shop text-default-gray\" style=\"font-size:100px;\" data-v-74ba6a3b></i><div class=\"flex flex-column\" data-v-74ba6a3b><h1 class=\"font-bold\" data-v-74ba6a3b>Boutique</h1><span class=\"app-label text-default-gray font-bold\" data-v-74ba6a3b>Des produits connectés pour un logement évolutif</span></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardTopRightButton = _resolveComponent("CardTopRightButton")!

  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.shopURL,
    target: "_blank",
    class: "pannel relative"
  }, [
    _createVNode(_component_CardTopRightButton, { icon: "ci-arrows-back" }),
    _hoisted_2
  ], 8, _hoisted_1))
}